// !(function () {
//   "use strict";
//   var t = ["DA", "DE", "EN", "ES", "FR", "IT", "JA", "NL", "PT", "PT_BR"];
//   function e(e) {
//     var n = e.replace(/-/, "_").toUpperCase();
//     return -1 !== t.indexOf(n)
//       ? n
//       : -1 !== t.indexOf(n.substring(0, 2))
//       ? n.substring(0, 2)
//       : "EN";
//   }
//   var n = /({\w+})/g,
//     r = {
//       lastName: '[name="address[last_name]"]',
//       firstName: '[name="address[first_name]"]',
//       company: '[name="address[company]"]',
//       address1: '[name="address[address1]"]',
//       address2: '[name="address[address2]"]',
//       country: '[name="address[country]"]',
//       zone: '[name="address[province]"]',
//       postalCode: '[name="address[zip]"]',
//       city: '[name="address[city]"]',
//       phone: '[name="address[phone]"]',
//     };
//   function s(t, n, s) {
//     n = n || "en";
//     var o = (function (t, e) {
//       var n = {};
//       return (
//         Object.keys(r).forEach(function (r) {
//           var s = t.querySelector(e[r]);
//           n[r] = s
//             ? {
//                 wrapper: s.parentElement,
//                 input: s,
//                 labels: document.querySelectorAll('[for="' + s.id + '"]'),
//               }
//             : {};
//         }),
//         n
//       );
//     })(
//       t,
//       (function () {
//         for (var t = Object({}), e = 0; e < arguments.length; e++) {
//           var n = arguments[e];
//           if (n)
//             for (var r in n)
//               Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
//         }
//         return t;
//       })(r, (s = s || { inputSelectors: {} }).inputSelectors)
//     );
//     return (
//       (function (t) {
//         Object.keys(t).forEach(function (e) {
//           var n = t[e].input,
//             r = t[e].labels;
//           if (n) {
//             if ("object" != typeof n)
//               throw new TypeError(t[e] + " is missing an input or select.");
//             if ("object" != typeof r)
//               throw new TypeError(t[e] + " is missing a label.");
//           }
//         });
//       })(o),
//       (function (t) {
//         if (!t) return Promise.resolve(null);
//         return fetch(location.origin + "/meta.json")
//           .then(function (t) {
//             return t.json();
//           })
//           .then(function (t) {
//             return -1 !== t.ships_to_countries.indexOf("*")
//               ? null
//               : t.ships_to_countries;
//           })
//           .catch(function () {
//             return null;
//           });
//       })(s.shippingCountriesOnly).then(function (r) {
//         return (function (t) {
//           return fetch("https://country-service.shopifycloud.com/graphql", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               "Access-Control-Allow-Origin": "*",
//             },
//             body: JSON.stringify({
//               query:
//                 "query countries($locale: SupportedLocale!) {  countries(locale: $locale) {    name    code    labels {      address1      address2      city      company      country      firstName      lastName      phone      postalCode      zone    }    formatting {      edit    }    zones {      name      code    }  }}",
//               operationName: "countries",
//               variables: { locale: e(t) },
//             }),
//           })
//             .then(function (t) {
//               return t.json();
//             })
//             .then(function (t) {
//               return t.data.countries;
//             });
//         })(n).then(function (e) {
//           !(function (t, e, n) {
//             !(function (t, e) {
//               var n = t.country.input,
//                 r = n.cloneNode(!0);
//               e.forEach(function (t) {
//                 var e = document.createElement("option");
//                 (e.value = t.code), (e.textContent = t.name), r.appendChild(e);
//               }),
//                 (n.innerHTML = r.innerHTML),
//                 n.dataset.default && (n.value = n.dataset.default);
//             })(e, n);
//             var r = e.country.input ? e.country.input.value : null;
//             (function (t, e, n) {
//               e.country.input.addEventListener("change", function (r) {
//                 a(t, e, r.target.value, n);
//               });
//             })(t, e, n),
//               a(t, e, r, n);
//           })(
//             t,
//             o,
//             (function (t, e) {
//               if (!e) return t;
//               return t.filter(function (t) {
//                 return -1 !== e.indexOf(t.code);
//               });
//             })(e, r)
//           );
//         });
//       })
//     );
//   }
//   function a(t, e, r, s) {
//     var a = (function (t, e) {
//       return (
//         (t = t || "CA"),
//         e.filter(function (e) {
//           return e.code === t;
//         })[0]
//       );
//     })(r, s);
//     !(function (t, e) {
//       Object.keys(t).forEach(function (n) {
//         t[n].labels.forEach(function (t) {
//           t.textContent = e.labels[n];
//         });
//       });
//     })(e, a),
//       (function (t, e, r) {
//         var s = r.formatting.edit,
//           a = e.country.wrapper,
//           o = !1;
//         ((i = s),
//         i.split("_").map(function (t) {
//           var e = t.match(n);
//           return e
//             ? e.map(function (t) {
//                 var e = t.replace(/[{}]/g, "");
//                 switch (e) {
//                   case "zip":
//                     return "postalCode";
//                   case "province":
//                     return "zone";
//                   default:
//                     return e;
//                 }
//               })
//             : [];
//         })).forEach(function (n) {
//           n.forEach(function (r) {
//             (e[r].wrapper.dataset.lineCount = n.length),
//               e[r].wrapper &&
//                 ("country" !== r
//                   ? o
//                     ? t.append(e[r].wrapper)
//                     : t.insertBefore(e[r].wrapper, a)
//                   : (o = !0));
//           });
//         });
//         var i;
//       })(t, e, a),
//       (function (t, e) {
//         var n = t.zone;
//         if (!n) return;
//         if (0 === e.zones.length)
//           return (
//             (n.wrapper.dataset.ariaHidden = "true"),
//             void (n.input.innerHTML = "")
//           );
//         n.wrapper.dataset.ariaHidden = "false";
//         var r = n.input,
//           s = r.cloneNode(!0);
//         (s.innerHTML = ""),
//           e.zones.forEach(function (t) {
//             var e = document.createElement("option");
//             (e.value = t.code), (e.textContent = t.name), s.appendChild(e);
//           }),
//           (r.innerHTML = s.innerHTML),
//           r.dataset.default && (r.value = r.dataset.default);
//       })(e, a);
//   }
//   const o = (t, e = [], n = !1) => {
//     const r = Object.keys(t)
//       .map((r) => {
//         let s = t[r];
//         if (
//           "[object Object]" === Object.prototype.toString.call(s) ||
//           Array.isArray(s)
//         )
//           return (
//             Array.isArray(t) ? e.push("") : e.push(r), o(s, e, Array.isArray(s))
//           );
//         {
//           let t = r;
//           if (e.length > 0) {
//             t = (n ? e : [...e, r]).reduce(
//               (t, e) => ("" === t ? e : `${t}[${e}]`),
//               ""
//             );
//           }
//           return n ? `${t}[]=${s}` : `${t}=${s}`;
//         }
//       })
//       .join("&");
//     return e.pop(), r;
//   };
//   function i(t) {
//     (this.status = t.status || null),
//       (this.headers = t.headers || null),
//       (this.json = t.json || null),
//       (this.body = t.body || null);
//   }
//   i.prototype = Error.prototype;
//   const c = "[data-template-no-shipping]",
//     u = ".get-rates",
//     l = "#address_container",
//     p = "#address_country",
//     h = "#address_province",
//     d = "#address_zip",
//     f = "#wrapper-response",
//     m = "#shipping-calculator-response-template",
//     g = "data-template-no-shipping",
//     y = "data-default",
//     v = "is-hidden",
//     b = "error",
//     C = "center",
//     E = "success",
//     _ = "disabled",
//     w = "get-rates--trigger",
//     B = "Error : country is not supported.",
//     A = "We do not ship to this destination.",
//     L = "Error : ";
//   class S extends HTMLElement {
//     constructor() {
//       super(),
//         (this.getRatesButton = this.querySelector(u)),
//         (this.fieldsContainer = this.querySelector(l)),
//         (this.selectCountry = this.querySelector(p)),
//         (this.selectProvince = this.querySelector(h)),
//         (this.template = this.querySelector(m)),
//         (this.wrapper = this.querySelector(f)),
//         (this.onCountryChangeEvent = () => this.onCountryChange()),
//         (this.onButtonClickEvent = () => this.onButtonClick());
//     }
//     connectedCallback() {
//       const t = document.querySelector("html");
//       let e = "en";
//       if (
//         (t.hasAttribute("lang") &&
//           "" !== t.getAttribute("lang") &&
//           (e = t.getAttribute("lang")),
//         this.fieldsContainer &&
//           s(this.fieldsContainer, e, { shippingCountriesOnly: !0 }),
//         this.selectCountry &&
//           this.selectCountry.hasAttribute(y) &&
//           this.selectProvince &&
//           this.selectProvince.hasAttribute(y) &&
//           this.selectCountry.addEventListener(
//             "change",
//             this.onCountryChangeEvent
//           ),
//         this.getRatesButton &&
//           (this.getRatesButton.addEventListener(
//             "click",
//             this.onButtonClickEvent
//           ),
//           theme.settings.customerLoggedIn &&
//             this.getRatesButton.classList.contains(w)))
//       ) {
//         const t = document.querySelector(d);
//         t && t.value && this.getRatesButton.dispatchEvent(new Event("click"));
//       }
//     }
//     disconnectedCallback() {
//       this.selectCountry &&
//         this.selectCountry.hasAttribute(y) &&
//         this.selectProvince &&
//         this.selectProvince.hasAttribute(y) &&
//         this.selectCountry.removeEventListener(
//           "change",
//           this.onCountryChangeEvent
//         ),
//         this.getRatesButton &&
//           this.getRatesButton.removeEventListener(
//             "click",
//             this.onButtonClickEvent
//           );
//     }
//     onCountryChange() {
//       this.selectCountry.removeAttribute(y),
//         this.selectProvince.removeAttribute(y);
//     }
//     onButtonClick() {
//       for (this.disableButtons(); this.wrapper.firstChild; )
//         this.wrapper.removeChild(this.wrapper.firstChild);
//       this.wrapper.classList.add(v);
//       const t = {};
//       let e = this.selectCountry.value,
//         n = this.selectProvince.value;
//       const r = this.selectCountry.getAttribute(y);
//       "" === e && r && "" !== r && (e = r);
//       const s = this.selectProvince.getAttribute(y);
//       "" === n && s && "" !== s && (n = s),
//         (t.zip = document.querySelector(d).value || ""),
//         (t.country = e || ""),
//         (t.province = n || ""),
//         this.getCartShippingRatesForDestination(t);
//     }
//     formatRate(t) {
//       const e =
//         "0.00" === t
//           ? window.theme.strings.free
//           : (function (t, e) {
//               "string" == typeof t && (t = t.replace(".", ""));
//               let n = "";
//               const r = /\{\{\s*(\w+)\s*\}\}/,
//                 s = e || "${{amount}}";
//               function a(t, e = 2, n = ",", r = ".") {
//                 if (isNaN(t) || null == t) return 0;
//                 const s = (t = (t / 100).toFixed(e)).split(".");
//                 return (
//                   s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${n}`) +
//                   (s[1] ? r + s[1] : "")
//                 );
//               }
//               switch (s.match(r)[1]) {
//                 case "amount":
//                   n = a(t, 2);
//                   break;
//                 case "amount_no_decimals":
//                   n = a(t, 0);
//                   break;
//                 case "amount_with_comma_separator":
//                   n = a(t, 2, ".", ",");
//                   break;
//                 case "amount_no_decimals_with_comma_separator":
//                   n = a(t, 0, ".", ",");
//                   break;
//                 case "amount_with_apostrophe_separator":
//                   n = a(t, 2, "'", ".");
//                   break;
//                 case "amount_no_decimals_with_space_separator":
//                   n = a(t, 0, " ", "");
//                   break;
//                 case "amount_with_space_separator":
//                   n = a(t, 2, " ", ",");
//                   break;
//                 case "amount_with_period_and_space_separator":
//                   n = a(t, 2, " ", ".");
//               }
//               return s.replace(r, n);
//             })(t, theme.moneyFormat);
//       return e;
//     }
//     render(t) {
//       function formatDate(input) {
//         var datePart = input.match(/\d+/g),
//           year = datePart[0].substring(2),
//           month = datePart[1],
//           day = datePart[2];
//         return day + "/" + month + "/" + year;
//       }

//       if (this.template && this.wrapper) {
//         this.wrapper.innerHTML = "";
//         let e = "",
//           n = "",
//           r = `${b} ${C}`,
//           s = this.template.innerHTML;
//         const a = /[^[\]]+(?=])/g;
//         if (t.rates && t.rates.length) {
//           let n = a.exec(s)[0];
//           t.rates.forEach((t) => {
//             let r = n;
//             (r = r.replace(
//               /\|\|rateName\|\|/,
//               t.name.replace(" (via Shippy)", "")
//             )),
//               (r = r.replace(/\|\|ratePrice\|\|/, this.formatRate(t.price))),
//               (r = r.replace(
//                 /\|\|rateDeliveryDate\|\|/,
//                 formatDate(t.delivery_date)
//               )),
//               (r = r.replace(/\|\|rateDay\|\|/, t.delivery_days[0])),
//               (e += r);
//           });
//         }
//         if (t.success) {
//           r = `${E} ${C}`;
//           const e = document.createElement("div");
//           e.innerHTML = this.template.innerHTML;
//           const s = e.querySelector(c);
//           t.rates.length < 1 && s && (n = s.getAttribute(g));
//         } else n = t.errorFeedback;
//         (s = s.replace(a, "").replace("[]", "")),
//           (s = s.replace(/\|\|ratesList\|\|/g, e)),
//           (s = s.replace(/\|\|successClass\|\|/g, r)),
//           (s = s.replace(/\|\|ratesText\|\|/g, n)),
//           (this.wrapper.innerHTML += s),
//           this.wrapper.classList.remove(v);
//       }
//     }
//     enableButtons() {
//       this.getRatesButton.removeAttribute("disabled"),
//         this.getRatesButton.classList.remove(_),
//         (this.getRatesButton.textContent =
//           theme.strings.shippingCalcSubmitButton);
//     }
//     disableButtons() {
//       this.getRatesButton.setAttribute("disabled", "disabled"),
//         this.getRatesButton.classList.add(_),
//         (this.getRatesButton.textContent =
//           theme.strings.shippingCalcSubmitButtonDisabled);
//     }
//     getCartShippingRatesForDestination(t) {
//       const e = encodeURI(o({ shipping_address: t })),
//         n = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
//       fetch(n)
//         .then(this.handleErrors)
//         .then((t) => t.text())
//         .then((e) => {
//           const n = JSON.parse(e).shipping_rates;
//           this.onCartShippingRatesUpdate(n, t);
//         })
//         .catch((t) => {
//           this.onError(t.json);
//         });
//     }
//     fullMessagesFromErrors(t) {
//       const e = [];
//       for (const n in t) for (const r of t[n]) e.push(r);
//       return e;
//     }
//     handleErrors(t) {
//       return t.ok
//         ? t
//         : t.json().then(function (e) {
//             throw new i({ status: t.statusText, headers: t.headers, json: e });
//           });
//     }
//     onError(t) {
//       this.enableButtons();
//       let e = "";
//       (e = t.message
//         ? t.message + "(" + t.status + "): " + t.description
//         : L + this.fullMessagesFromErrors(t).join("; ")),
//         e === B && (e = A),
//         this.render({ rates: [], errorFeedback: e, success: !1 });
//     }
//     onCartShippingRatesUpdate(t, e) {
//       this.enableButtons();
//       let n = "";
//       e.zip && (n += e.zip + ", "),
//         e.province && (n += e.province + ", "),
//         (n += e.country),
//         this.render({ rates: t, address: n, success: !0 });
//     }
//   }
//   customElements.get("shipping-calculator") ||
//     customElements.define("shipping-calculator", S);
// })();
(() => {
  const ELEMENT_NAME = "cart-shipping-calculator";

  if (customElements.get(ELEMENT_NAME)) {
    return;
  }

  const STATES = {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapá",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceará",
    DF: "Distrito Federal",
    ES: "Espírito Santo",
    GO: "Goiás",
    MA: "Maranhão",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Pará",
    PB: "Paraíba",
    PR: "Paraná",
    PE: "Pernambuco",
    PI: "Piauí",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondônia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "São Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  };

  const MONEY_FORMATTER = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  const wait = (milliseconds) =>
    new Promise((resolve) => setTimeout(resolve, milliseconds));

  const escapeHtml = (value) =>
    String(value ?? "").replace(/[&<>"']/g, (character) => {
      const characters = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      };

      return characters[character];
    });

  const getRoute = (path) => {
    let root = window.Shopify?.routes?.root || "/";

    if (!root.endsWith("/")) {
      root += "/";
    }

    return `${root}${path.replace(/^\/+/, "")}`;
  };

  class CartShippingCalculator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === "true") {
        return;
      }

      this.dataset.initialized = "true";

      this.input = this.querySelector("[data-shipping-zip]");
      this.button = this.querySelector("[data-shipping-submit]");
      this.response = this.querySelector("[data-shipping-response]");

      if (!this.input || !this.button || !this.response) {
        console.error(
          "Calculadora de frete: os elementos obrigatórios não foram encontrados."
        );
        return;
      }

      this.originalButtonText = this.button.textContent.trim();

      this.button.addEventListener("click", () => {
        this.calculate();
      });

      this.input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          this.calculate();
        }
      });

      this.input.addEventListener("input", () => {
        const digits = this.input.value.replace(/\D/g, "").slice(0, 8);

        this.input.value =
          digits.length > 5
            ? `${digits.slice(0, 5)}-${digits.slice(5)}`
            : digits;
      });
    }

    setLoading(isLoading) {
      this.button.disabled = isLoading;
      this.button.setAttribute("aria-busy", String(isLoading));

      this.button.textContent = isLoading
        ? "Calculando..."
        : this.originalButtonText;
    }

    showError(message) {
      this.response.innerHTML = `
        <p class="shipping-rates-feedback error">
          ${escapeHtml(message)}
        </p>
      `;
    }

    async getCart() {
      const response = await fetch(getRoute("cart.js"), {
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Não foi possível consultar o carrinho.");
      }

      return response.json();
    }

    async getAddress(zip) {
      const response = await fetch(
        `https://viacep.com.br/ws/${encodeURIComponent(zip)}/json/`
      );

      if (!response.ok) {
        throw new Error("Não foi possível consultar o CEP.");
      }

      const address = await response.json();

      if (
        address.erro ||
        !address.uf ||
        !address.localidade
      ) {
        throw new Error("CEP não encontrado. Confira os números informados.");
      }

      return {
        zip,
        city: address.localidade,
        stateCode: address.uf,
        stateName: STATES[address.uf] || address.uf,
        country: "Brazil",
      };
    }

    createAddressParams(address) {
      const params = new URLSearchParams();

      params.set("shipping_address[zip]", address.zip);
      params.set("shipping_address[country]", address.country);
      params.set("shipping_address[province]", address.stateName);
      params.set("shipping_address[city]", address.city);

      return params;
    }

    async prepareRates(params) {
      const response = await fetch(
        `${getRoute("cart/prepare_shipping_rates.json")}?${params.toString()}`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        }
      );

      if (response.ok || response.status === 202) {
        return;
      }

      if (response.status === 429) {
        throw new Error(
          "Muitas consultas foram realizadas. Aguarde alguns segundos e tente novamente."
        );
      }

      let message = "Não foi possível iniciar o cálculo do frete.";

      try {
        const error = await response.json();

        message =
          error?.description ||
          error?.message ||
          message;
      } catch (error) {
        // Mantém a mensagem padrão.
      }

      throw new Error(message);
    }

    async pollRates(params) {
      const url =
        `${getRoute("cart/async_shipping_rates.json")}?${params.toString()}`;

      const maxAttempts = 15;

      for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
        const response = await fetch(url, {
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (response.status === 429) {
          throw new Error(
            "Muitas consultas foram realizadas. Aguarde alguns segundos e tente novamente."
          );
        }

        if (!response.ok) {
          throw new Error("Não foi possível consultar as opções de frete.");
        }

        const data = await response.json();

        if (data && Array.isArray(data.shipping_rates)) {
          return data.shipping_rates;
        }

        await wait(700);
      }

      throw new Error(
        "O cálculo demorou mais que o esperado. Tente novamente."
      );
    }

    getDeliveryText(rate) {
      if (
        Array.isArray(rate.delivery_days) &&
        rate.delivery_days.length > 0
      ) {
        const days = rate.delivery_days
          .map((day) => Number(day))
          .filter((day) => Number.isFinite(day));

        if (days.length > 0) {
          const minimum = Math.min(...days);
          const maximum = Math.max(...days);

          if (minimum === maximum) {
            return ` — prazo estimado de ${maximum} dias úteis`;
          }

          return ` — prazo estimado de ${minimum} a ${maximum} dias úteis`;
        }
      }

      if (rate.delivery_date) {
        const date = new Date(`${rate.delivery_date}T12:00:00`);

        if (!Number.isNaN(date.getTime())) {
          return ` — entrega estimada em ${date.toLocaleDateString("pt-BR")}`;
        }
      }

      return "";
    }

    getPriceText(rate) {
      const price = Number.parseFloat(
        String(rate.price ?? "").replace(",", ".")
      );

      if (!Number.isFinite(price)) {
        return escapeHtml(rate.price || "");
      }

      if (price === 0) {
        return "Grátis";
      }

      return MONEY_FORMATTER.format(price);
    }

    renderRates(rates, address) {
      if (!rates.length) {
        this.showError(
          "Nenhuma opção de frete foi encontrada para este CEP."
        );
        return;
      }

      const ratesHtml = rates
        .map((rate) => {
          const name = escapeHtml(
            rate.presentment_name ||
            rate.name ||
            rate.code ||
            "Entrega"
          );

          const price = this.getPriceText(rate);
          const delivery = this.getDeliveryText(rate);

          return `
            <li class="shipping-rate">
              <div class="rate__info">
                <strong>${name}:</strong>
                <span>
                  <strong>${price}</strong>${escapeHtml(delivery)}
                </span>
              </div>
            </li>
          `;
        })
        .join("");

      this.response.innerHTML = `
        <div class="shipping-calculator__result">
          <p class="heading">
            Opções de frete para
            <strong>
              ${escapeHtml(address.city)} –
              ${escapeHtml(address.stateCode)}
            </strong>
          </p>

          <ul class="shipping_rates" id="shipping-rates">
            ${ratesHtml}
          </ul>

          <p class="result__information">
            * Os valores e prazos são estimativas e serão confirmados no checkout.
          </p>
        </div>
      `;
    }

    async calculate() {
      const zip = this.input.value.replace(/\D/g, "");

      this.response.innerHTML = "";

      if (zip.length !== 8) {
        this.showError("Digite um CEP válido com 8 números.");
        this.input.focus();
        return;
      }

      this.setLoading(true);

      try {
        const cart = await this.getCart();

        if (!cart.item_count) {
          throw new Error(
            "Adicione pelo menos um produto ao carrinho para calcular o frete."
          );
        }

        const address = await this.getAddress(zip);
        const params = this.createAddressParams(address);

        await this.prepareRates(params);

        const rates = await this.pollRates(params);

        this.renderRates(rates, address);
      } catch (error) {
        console.error("Erro ao calcular frete:", error);

        this.showError(
          error?.message ||
          "Ocorreu um erro durante o cálculo do frete."
        );
      } finally {
        this.setLoading(false);
      }
    }
  }

  customElements.define(ELEMENT_NAME, CartShippingCalculator);
})();